<div class="container-fluid container-content">
	<div class="row">
		<div class="col-md-12">
			<router-outlet></router-outlet>
		</div>		
	</div>
</div>